var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{class:{
        'required-field': _vm.required,
    },attrs:{"label":_vm.inputLabel,"label-for":_vm.inputId}},[_c('b-form-file',_vm._b({ref:"file-input",attrs:{"id":_vm.inputId,"name":_vm.inputName,"disabled":_vm.loading || _vm.disabled,"placeholder":_vm.getPlaceholder()},on:{"input":_vm.fileCompressor}},'b-form-file',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }